export enum ModelVersionStatusType {
  pending = 'Pending',
  active = 'Active',
  inactive = 'Inactive',
}
